import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTheme } from '../context/ThemeContext';
import HeroHeader from '../components/HeroHeader';
import FAQBg from '../assets/images/header-backgrounds/background2.png';
import { Section, FAQAccordion, StyledAccordionSummary, StyledAccordionDetails } from '../components/styled/CommonStyles';

function FAQPage() {
  const { currentTheme } = useTheme();

  return (
    <>
      <HeroHeader 
        title="Frequently Asked Questions" 
        backgroundImage={FAQBg}
      />

      <Section theme={currentTheme}>
        <Container>
          <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">What services does Hawkins Carpet Cleaning offer?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  At Hawkins Carpet Cleaning, we specialize in low-moisture carpet cleaning, upholstery cleaning, 
                  stain removal, and pet odor treatment. Our eco-friendly cleaning methods leave your carpets fresh, 
                  clean, and dry in as little as 90 minutes!
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">How do I schedule an appointment?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Booking your carpet cleaning service is easy! You can call us directly or use our convenient 
                  online booking system on our website: HawkinsCarpet.com.
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">Are your cleaning products safe for children and pets?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Absolutely! We use non-toxic, eco-friendly cleaning solutions that are safe for children, pets, 
                  and allergy-sensitive individuals. Your family's health and safety are our top priorities.
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">Do you offer any discounts or promotions?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Yes! We frequently run seasonal promotions and special offers. Follow us on social media and check 
                  our website for the latest deals. Don't miss out on savings!
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">How long does carpet cleaning take?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Our low-moisture cleaning method ensures fast and efficient service. Most jobs take 1 to 2 hours, 
                  and carpets dry in just 90 minutes, so you can get back to enjoying your space in no time.
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">Can you remove tough stains like wine, coffee, or pet accidents?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Yes! Our advanced enzyme-based stain removal solutions effectively break down tough stains, including 
                  wine, coffee, pet accidents, and more. We'll restore your carpets to their best condition!
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">What areas do you serve?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  We proudly serve Daviess and the surrounding counties. Contact us to confirm if we cover your 
                  location—we'd love to help refresh your home!
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">Do you offer emergency or same-day cleaning services?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  Yes! We understand accidents happen, which is why we offer emergency carpet cleaning services when 
                  available. Call us as soon as possible, and we'll do our best to accommodate you.
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>

            <FAQAccordion theme={currentTheme}>
              <StyledAccordionSummary theme={currentTheme}>
                <Typography variant="h6">What payment methods do you accept?</Typography>
              </StyledAccordionSummary>
              <StyledAccordionDetails>
                <Typography>
                  We accept cash, credit/debit cards, and mobile payment options for your convenience. Our goal is 
                  to make the process smooth and hassle-free.
                </Typography>
              </StyledAccordionDetails>
            </FAQAccordion>
          </Box>
        </Container>
      </Section>
    </>
  );
}

export default FAQPage;
